import React from "react";
import {Link} from "react-router-dom";
import styled from "styled-components";
import {StyledButton} from "../../../Common/Components";
import ImageDisplay from "../../../Common/Components/Base/Images/ImageDisplay";
import ImageUploader from "../../../Common/Components/Base/Images/ImageUploader";
import PermissionCheck from "../../../Common/PermissionCheck";
import {PermissionNames, PermissionOperations} from "~enums/permissions";

const ImageEditCell = styled.div`
    display: flex;
    justify-content: left;
    align-content: center;
    gap: 20px;
    height: 100%;
`;

export const getColumns = ({formatMessage, pageRef, setRefreshFlag, customerId, sport}) => [
    {
        title: formatMessage({
            id: "name.local.full",
            defaultMessage: "Local Full Name",
        }),
        dataIndex: "nameFullLocal",
    },
    {
        title: formatMessage({
            id: "images.headshot",
            defaultMessage: "Head Shot Photo",
        }),
        render: (value, row) => (
            <ImageEditCell>
                <ImageDisplay
                    data={row}
                    images={row.images}
                    imageType="PERSON_HEAD"
                    pageRef={pageRef}
                    setRefreshFlag={setRefreshFlag}
                    checkQuality={true}
                    permissionKey={PermissionNames.PERSON}
                />
                <PermissionCheck permissionKeys={[PermissionNames.PERSON]} permissionOptions={[PermissionOperations.UPDATE]}>
                    <ImageUploader
                        data={row}
                        type={"PERSON_HEAD"}
                        element={"personId"}
                        imageFor={"PERSON"}
                        pageRef={pageRef}
                        setRefreshFlag={setRefreshFlag}
                    />
                </PermissionCheck>
            </ImageEditCell>
        ),
    },
    {
        title: formatMessage({
            id: "images.waist",
            defaultMessage: "Waist Shot Photo",
        }),
        render: (value, row) => (
            <ImageEditCell>
                <ImageDisplay
                    data={row}
                    images={row.images}
                    imageType="PERSON_WAIST"
                    pageRef={pageRef}
                    setRefreshFlag={setRefreshFlag}
                    checkQuality={true}
                    permissionKey={PermissionNames.PERSON}
                />
                <PermissionCheck permissionKeys={[PermissionNames.PERSON]} permissionOptions={[PermissionOperations.UPDATE]}>
                    <ImageUploader
                        data={row}
                        type={"PERSON_WAIST"}
                        element={"personId"}
                        imageFor={"PERSON"}
                        pageRef={pageRef}
                        setRefreshFlag={setRefreshFlag}
                    />
                </PermissionCheck>
            </ImageEditCell>
        ),
    },
    {
        title: formatMessage({
            id: "images.pose",
            defaultMessage: "Posed / Action Shot Photo",
        }),
        render: (value, row) => (
            <ImageEditCell>
                <ImageDisplay
                    data={row}
                    images={row.images}
                    imageType="PERSON_POSE"
                    pageRef={pageRef}
                    setRefreshFlag={setRefreshFlag}
                    checkQuality={true}
                    permissionKey={PermissionNames.PERSON}
                />
                <PermissionCheck permissionKeys={[PermissionNames.PERSON]} permissionOptions={[PermissionOperations.UPDATE]}>
                    <ImageUploader
                        data={row}
                        type={"PERSON_POSE"}
                        element={"personId"}
                        imageFor={"PERSON"}
                        pageRef={pageRef}
                        setRefreshFlag={setRefreshFlag}
                    />
                </PermissionCheck>
            </ImageEditCell>
        ),
    },
    {
        render: (value, row) => (
            <StyledButton type="text" size="small">
                <Link to={`/${customerId}/admin/${sport}/${row.organizationId}/persons/manage/${row.personId}`}>
                    {formatMessage({
                        id: "details",
                        defaultMessage: "Details",
                    })}
                </Link>
            </StyledButton>
        ),
    },
];
